<app-toast></app-toast>
<app-payment-method-update-dialog></app-payment-method-update-dialog>
<app-delete-card-dialog></app-delete-card-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.settings' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.company_information' | transloco }}"
                    link="/settings/company"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.my_profile' | transloco }}"
                    link="/settings/profile"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.team' | transloco }}" link="/settings/team"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.billing' | transloco }}" link="/settings/billing"
                    [isActive]="true"></app-tab-button>
                <app-tab-button label="{{ 'settings.button.plans' | transloco }}"
                    link="/settings/plans"></app-tab-button>
            </div>

            <!-- Subscription information -->
            <div
                class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">
                <!-- Header text -->
                <div class="flex">
                    <div class="flex flex-col gap-4 min-h-[60px] justify-between">
                        <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                            'settings.subscription_overview'
                            | transloco }}
                        </p>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="min-h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
                <!-- Content -->
                <div class="flex gap-5 flex-col p-5">
                    <div class="flex flex-wrap gap-2">
                        <div class="flex gap-2 flex-[1] min-w-[300px] items-start">
                            <img src="assets/icons/power-primary.svg" alt="{{ 'shared.icon' | transloco }}"
                                class="w-[24px] h-[24px]">
                            <div class="flex flex-col">
                                @if(subscriptionNotActive) {
                                <p>{{ 'settings.subscription.previous_plan' |
                                    transloco
                                    }}
                                </p>
                                }
                                @else {
                                <p>{{ 'settings.subscription.current_plan' |
                                    transloco
                                    }}
                                </p>
                                }
                                <p><strong class="text-md">{{ currentPlan }}</strong><a
                                        class="text-primary hover:underline ml-2 hover:cursor-pointer"
                                        (click)="openCustomerPanel()">{{
                                        'settings.subscription.manage' | transloco }}</a></p>
                            </div>
                        </div>

                        <div class="flex gap-2 flex-[1] min-w-[300px] items-start">
                            <img src="assets/icons/calendar-primary.svg" alt="{{ 'dashboard.calendar' | transloco }}"
                                class="w-[24px] h-[24px]">
                            <div class="flex flex-col">
                                <p>{{ 'settings.subscription.next_billing_date' |
                                    transloco
                                    }}
                                </p>
                                @if(subscriptionNotActive) {
                                <p class="text-error-500">{{ 'settings.subscription.not_active' | transloco}}</p>
                                }
                                @else
                                {
                                <p><span class="text-md">{{ nextBillingDate }}</span></p>
                                }
                            </div>
                        </div>

                        <div class="flex gap-2 flex-[1] min-w-[300px] items-start">
                            <img src="assets/icons/cards/card.svg" alt="{{ 'dashboard.calendar' | transloco }}"
                                class="w-[24px] h-[24px]">
                            <div class="flex flex-col">
                                <p>{{ 'shared.amount' |
                                    transloco
                                    }}
                                </p>
                                <p><span class="text-md">€ {{ amount }} / {{ (billedYearly ? 'shared.year' :
                                        'shared.month') |
                                        transloco
                                        }}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Payment methods -->
            <div
                class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">
                <!-- Header text -->
                <div class="flex">
                    <div class="flex flex-col gap-4 min-h-[60px] justify-between">
                        <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{
                            'settings.subscription.payment_method'
                            | transloco }}
                        </p>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="min-h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>
                <!-- Content -->
                <div *ngIf="paymentMethods?.length;" class="w-full flex flex-col gap-2">
                    <div *ngFor="let card of paymentMethods">
                        <app-payment-card [paymentMethod]="card" (paymentSetAsDefault)="setAsDefaultClick($event)"
                            (deletePaymentMethod)="deletePaymentMethod($event)"></app-payment-card>
                    </div>
                </div>
            </div>

            <!-- Billing Information -->
            <div
                class="mt-5 pb-5 w-full max-w-ultrawide min-w-[300px] h-auto border-[1px] border-border rounded-[20px] flex flex-col mobile:w-full">
                <!-- Header text -->
                <div class="flex w-full">
                    <div class="flex flex-col gap-4 min-h-[60px] justify-between min-w-[180px] mobile:mix-w-[50px]">
                        <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">
                            {{ 'shared.labels.billing_information' | transloco }}
                        </p>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="min-h-[60px] flex flex-col justify-end items-end w-full">
                        <div class="w-[150px] h-[50px] m-4 mobile:m-2"
                            [ngClass]="!customerDataLoaded ? 'flex justify-center items-center' : ''">
                            @if (!customerDataLoaded) {
                            <span class="loading loading-dots loading-xl"></span>
                            }
                            @else if (editingInputDisabled) {
                            <app-custom-button buttonText="{{ 'settings.button.edit' | transloco }}"
                                [isDisabled]="false" backgroundColor="bg-primary" textColor="text-white"
                                borderColor="border:bg-primary" hoverBackgroundColor="hover:bg-primary-1200"
                                trailingIcon="assets/icons/settings/edit.svg" (click)="onEditClick()">
                            </app-custom-button>
                            }
                            @else {
                            <app-custom-button buttonText="{{ 'shared.save' | transloco }}" [isDisabled]="false"
                                backgroundColor="bg-secondary" textColor="text-white" borderColor="border:bg-secondary"
                                hoverBackgroundColor="hover:bg-secondary-1200"
                                hoverBorderColor="hover:border-secondary-1200"
                                trailingIcon="assets/icons/upload-white.svg" (click)="onEditClick()">
                            </app-custom-button>
                            }
                        </div>
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                </div>

                <!-- Content -->
                <div class="m-4 flex flex-col">
                    <div class="w-full flex flex-wrap gap-5">
                        <!-- Email -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.email' | transloco }}"
                                [inputId]="'email'" [inputType]="'email'" [(inputValue)]="billingEmail"
                                [errorMessage]="billingEmailError"
                                placeholder="{{ 'shared.placeholders.billing.email' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <!-- Name -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.name' | transloco }}"
                                [inputId]="'name'" [inputType]="'text'" [(inputValue)]="billingName"
                                [errorMessage]="billingNameError"
                                placeholder="{{ 'shared.placeholders.billing.name' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>
                    </div>

                    <div class="w-full flex flex-wrap gap-5">
                        <!-- City -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.city' | transloco }}"
                                [inputId]="'city'" [inputType]="'text'" [(inputValue)]="billingCity"
                                [errorMessage]="billingCityError"
                                placeholder="{{ 'shared.placeholders.billing.city' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <!-- Country -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-custom-dropdown [options]="countriesDropdownOptions"
                                [(selectedOption)]="selectedCountry"
                                label="{{ 'shared.labels.billing.country_code' | transloco }}"
                                placeholder="{{ 'shared.placeholders.billing.country_code' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabled]="editingInputDisabled"
                                [errorMessage]="selectedCountryError" [disabledTitle]="clickEditTitle">
                            </app-custom-dropdown>
                        </div>
                    </div>

                    <div class="w-full flex flex-wrap gap-5">
                        <!-- Address -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.address' | transloco }}"
                                [inputId]="'address'" [inputType]="'text'" [(inputValue)]="billingAddress"
                                [errorMessage]="billingAddressError"
                                placeholder="{{ 'shared.placeholders.billing.address' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <!-- Postal Code -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.postal_code' | transloco }}"
                                [inputId]="'postal_code'" [inputType]="'text'" [(inputValue)]="billingPostalCode"
                                [errorMessage]="billingPostalCodeError"
                                placeholder="{{ 'shared.placeholders.billing.postal_code' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>
                    </div>

                    <div class="w-full flex flex-wrap gap-5">
                        <!-- State -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.state' | transloco }}"
                                [inputId]="'state'" [inputType]="'text'" [(inputValue)]="billingState"
                                [errorMessage]="billingStateError"
                                placeholder="{{ 'shared.placeholders.billing.state' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>

                        <!-- PEC Email Address -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.pec_email_address' | transloco }}"
                                [inputId]="'pec_email_address'" [inputType]="'text'"
                                [(inputValue)]="billingPecEmailAddress" [errorMessage]="billingPecEmailAddressError"
                                placeholder="{{ 'shared.placeholders.billing.pec_email_address' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabledTitle]="clickEditTitle"
                                [isDisabled]="editingInputDisabled"></app-labeled-input>
                        </div>

                        <!-- SDI -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.sdi' | transloco }}"
                                [inputId]="'sdi'" [inputType]="'text'" [(inputValue)]="billingSdi"
                                [errorMessage]="billingSdiError"
                                placeholder="{{ 'shared.placeholders.billing.sdi' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [disabledTitle]="clickEditTitle"
                                [isDisabled]="editingInputDisabled"></app-labeled-input>
                        </div>

                        <!-- VAT ID -->
                        <div class="flex-[1] min-w-[300px] mobile:w-full">
                            <app-labeled-input labelText="{{ 'shared.labels.billing.vat_id' | transloco }}"
                                [inputId]="'vat_id'" [inputType]="'text'" [(inputValue)]="billingVatId"
                                [errorMessage]="billingVatIdError"
                                placeholder="{{ 'shared.placeholders.billing.vat_id' | transloco }}"
                                boxHeight="h-[5vh] min-h-[50px] max-h-[70px]" [isDisabled]="editingInputDisabled"
                                [disabledTitle]="clickEditTitle"></app-labeled-input>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Billing History -->
            <div class="mt-5 flex flex-wrap gap-2 justify-between items-center">
                <div class="flex flex-col">
                    <p class="font-bold">{{ 'settings.billing_history' | transloco }} ({{listOfBillingHistory.length}})
                    </p>
                    <p class="text-neutral-1200">{{ 'settings.see_billing_history' | transloco }}</p>
                </div>
            </div>

            <div
                class="overflow-x-auto mt-5 max-w-ultrawide h-full mobile:max-w-screen overflow-y-auto border-[1px] border-border rounded-[16px] block">
                <table class="table w-full border-collapse">
                    <!-- Header -->
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'invoice.period' | transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'shared.pages.invoice' | transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.date' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'shared.amount' | transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'shared.status' | transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal"></th>
                        </tr>
                    </thead>
                    <!-- Content -->
                    <tbody *ngIf="listOfBillingHistory.length">
                        <ng-container *ngFor="let item of listOfBillingHistory; let i = index">
                            <tr class="max-h-[50px]">
                                <td class="border-b border-border px-4 py-4">{{ item.paid_at | isoPeriod }}</td>
                                <td class="border-b border-border px-4 py-4">{{ item.invoice_number }}</td>
                                <td class="border-b border-border px-4 py-4">{{ item.paid_at | isoDate }}</td>
                                <td class="border-b border-border px-4 py-4">{{ getPriceFromStripeTotal(item.total) |
                                    number:'1.2-2' }}€
                                </td>
                                <td class="border-b border-border px-4 py-4"><app-invoice-status
                                        [status]="(item.status == 'paid')"></app-invoice-status></td>
                                <td class="border-b border-border px-4 py-4"><button
                                        (click)="downloadInvoice(item.invoice_url)"><img
                                            src="assets/icons/archive/download-circle.svg"
                                            alt="{{ 'shared.download' | transloco }}"
                                            title="{{ 'shared.download' | transloco }}"></button></td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="listOfBillingHistory.length && !loadMoreHidden">
                            <td colspan="6">
                                <div class="w-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="billingHistoryDataIsLoading" backgroundColor="bg-neutral-500"
                                            textColor="text-white" borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadBillingHisotry()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>